module.exports = __webpack_public_path__ + "static/media/1.dc995ca4.png";